import { useChatContext } from '@/contexts/chat/context';
import { useSessionContext } from '@/contexts/session/context';
import EditIcon from '../../images/edit.svg?react';
import ChatIcon from '../../images/chat.svg?react';
import styles from './index.module.scss';

const SelfActions = () => {
  const { showProfileInfo, setShowProfileInfo } = useSessionContext();
  const { info } = showProfileInfo;
  const { createOrActiveChat } = useChatContext();
  const navData = [
    {
      key: 'Edit',
      icon: <EditIcon />,
      text: 'Edit',
      onclick: () => {
        setShowProfileInfo({ show: false, showEdit: true });
      },
    },
    {
      key: 'Chat',
      icon: <ChatIcon />,
      text: 'Chat',
      onclick: async () => {
        await createOrActiveChat({ userId: info.userId! }).catch((_) => '');
        setShowProfileInfo({ show: false, showEdit: false });
      },
    },
  ];

  return (
    <div className={styles.selfActions}>
      {navData.map((item) => {
        return (
          <div key={item.key} className={styles.item} onClick={item?.onclick}>
            <div>{item.icon}</div>
            <div className={styles.text}>{item.text}</div>
          </div>
        );
      })}
    </div>
  );
};

export default SelfActions;
